import './bootstrap.js'

import { ClassicEditor, Essentials, Bold, Italic, Font, Paragraph, Heading, List, Image, ImageUpload, Link, SourceEditing, Table } from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';
import 'ckeditor5/ckeditor5-editor.css';
import 'ckeditor5/ckeditor5-content.css';
import '@ckeditor/ckeditor5-image/theme/image.css';

document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.description').forEach(element => {
        const initialValue = element.getAttribute('data-content') || '';
        ClassicEditor
            .create(element, {
                plugins: [Essentials, Bold, Italic, Font, Paragraph, Heading, List, Image, ImageUpload, Link, SourceEditing, Table],
                toolbar: {
                    items: [
                        'undo', 'redo', '|', 'heading', '|',
                        'bold', 'italic', '|',
                        'numberedList', 'bulletedList', '|',
                        'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
                        'imageUpload', 'link','insertTable', 'sourceEditing'
                    ]
                },
                table: {
                    contentToolbar: [
                        'tableColumn', 'tableRow', 'mergeTableCells'
                    ]
                },          
                image: {
                    toolbar: [
                        'imageTextAlternative',  // Agregar el campo de texto alternativo para imágenes
                        'imageStyle:full',  // Opciones adicionales de estilo de imagen si es necesario
                        'imageStyle:alignLeft',
                        'imageStyle:alignRight'
                    ],
                    styles: [
                        'full',
                        'alignLeft',
                        'alignRight'
                    ]
                },
                link: {
                    decorators: {
                        openInNewTab: {
                            mode: 'manual',
                            label: 'Open in a new tab',
                            attributes: {
                                target: '_blank',
                                rel: 'noopener noreferrer'
                            }
                        }
                    }
                },
                upload: {
                    uploadUrl: '/upload-image'
                },
                //extraAllowedContent: 'div(*)[*]{*}; p(*)[*]{*}',
                allowedContent: true, // Permitir todo tipo de contenido
                disallowedContent: '', // No deshabilitar contenido
                autoParagraph: false, // No convertir en <p> automáticamente
                //enterMode: ClassicEditor.ENTER_DIV, // Insertar <div> al presionar Enter
                data: {
                    allowAttributes: true,
                    allowTags: true,
                },
                autoGrowMinHeight: 500, // Mantener la altura mínima en 500px
                autoGrow: {
                    minHeight: 500
                }
            })
            .then(editor => {
                element.editorInstance = editor;
            })
            .catch(error => {
                console.error('Error creating editor:', error);
            });
    });
        
    const jsevent = document.querySelector('.js-event');
    
    if (jsevent) { //controlo que sea la página de eventos para evitar errores
        const placeSelect = document.querySelector('#place_id');
        const siteSelect = document.querySelector('#site_id');

        placeSelect.addEventListener('change', function(event) {
            const selectedOption = event.target.selectedOptions[0];
            const place = selectedOption.getAttribute('place');

            if (place === '0') {
                siteSelect.selectedIndex = 0;
                siteSelect.classList.remove('select-disabled');
            } else {
                const optionToSelect = Array.from(siteSelect.options).find(option => option.value === place);
                if (optionToSelect) {
                    optionToSelect.selected = true;
                }
                siteSelect.classList.add('select-disabled');
            }

        });


        document.getElementById('openPopupSitio').addEventListener('click', function(event) {
            event.preventDefault(); // Evita la navegación estándar del enlace
            var url = this.href;
            document.getElementById('popupIframe').src = url;
            document.getElementById('popupContainer').classList.add('show');
        });
        document.getElementById('btCloseSitio').addEventListener('click', function(event) {
            document.getElementById('popupContainer').classList.remove('show');
            document.getElementById('popupIframe').src = ''; // Limpia el contenido del iframe
        });
        /*
        document.querySelectorAll('.description').forEach(element => {
            const initialValue = element.getAttribute('data-content') || '';
            ClassicEditor
                .create(element, {
                    plugins: [Essentials, Bold, Italic, Font, Paragraph, Heading, List, Image, ImageUpload],
                    toolbar: {
                        items: [
                            'undo', 'redo', '|', 'heading', '|',
                            'bold', 'italic', '|',
                            'numberedList', 'bulletedList', '|',
                            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
                            'imageUpload',  
                        ]
                    },
                    image: {
                        toolbar: [
                            'imageTextAlternative',  // Agregar el campo de texto alternativo para imágenes
                            'imageStyle:full',  // Opciones adicionales de estilo de imagen si es necesario
                            'imageStyle:alignLeft',
                            'imageStyle:alignRight'
                        ],
                        styles: [
                            'full',
                            'alignLeft',
                            'alignRight'
                        ]
                    },
                    upload: {
                        uploadUrl: '/upload-image'
                    },
                    data: {
                        allowAttributes: true,
                        allowTags: true,
                    },
                    autoGrowMinHeight: 500, // Mantener la altura mínima en 500px
                    autoGrow: {
                        minHeight: 500
                    }
                })
                .then(editor => {
                    element.editorInstance = editor;
                })
                .catch(error => {
                    console.error('Error creating editor:', error);
                });
        });
        */
        document.querySelector('#btcreateEvent').addEventListener('click', function(event) {
            event.preventDefault(); 
            
            const form = document.querySelector('#fCreateEvent');
            if (!form.checkValidity()) {
                form.reportValidity(); 
                return; 
            }
            document.querySelectorAll('.description').forEach(element => {
                const editorInstance = element.editorInstance;
                if (editorInstance) {
                    const editorData = editorInstance.getData();

                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = `${element.getAttribute('name')}_content`;
                    hiddenField.value = editorData;
                    document.querySelector('#fCreateEvent').appendChild(hiddenField);
                }
            });

            document.querySelector('#fCreateEvent').submit();
        });
        
    }    
    //fin
    const jsitineraries = document.querySelector('.js-itineraries');
    if (jsitineraries){
        const numberDaysInput = document.getElementById('number_days');
        const multiSelectContainers = document.getElementById('multiSelectContainers');
        const eventsData = JSON.parse(document.getElementById('eventsData').value);
        const eventsSelected = JSON.parse(document.getElementById('eventsSelected').value);

        // Objeto para almacenar las selecciones de cada selector
        let selectionsBackup = {};
        
        // Inicialización al cargar la página
        initialize();

        // Función para inicializar el número de días y los selectores
        function initialize() {
            const numberDays = parseInt(numberDaysInput.value);
            createMultiSelectContainers(numberDays);
            loadSelectedOptions();
        }

        document.querySelector('#sites_itinerary').addEventListener('change', function() {
            const selectedSiteId = this.value; 
            const availableOptions = document.querySelectorAll('.available-options option'); 
            availableOptions.forEach(option => {
                const siteId = option.getAttribute('data-site-id');
                if (siteId === selectedSiteId) {
                    option.style.display = '';  
                } else {
                    option.style.display = 'none';  
                }
            });
        });


        // Escuchar cambios en el input number_days
        numberDaysInput.addEventListener('change', function() {
            const numberDays = parseInt(this.value);
            updateMultiSelectContainers(numberDays);
        });

        // Función para actualizar los selectores
        function updateMultiSelectContainers(numberDays) {
            const currentNumberDays = multiSelectContainers.children.length;

            if (numberDays > currentNumberDays) {
                // Agregar selectores adicionales si se necesita
                for (let day = currentNumberDays + 1; day <= numberDays; day++) {
                    const dayContainer = createDayContainer(eventsData, day);
                    multiSelectContainers.appendChild(dayContainer);
                }
            } else if (numberDays < currentNumberDays) {
                // Eliminar el último selector si se necesita
                while (multiSelectContainers.children.length > numberDays) {
                    multiSelectContainers.removeChild(multiSelectContainers.lastChild);
                }
            }
            loadSelectedOptions();
        }

        // Función para crear todos los selectores iniciales
        function createMultiSelectContainers(numberDays) {
            for (let day = 1; day <= numberDays; day++) {
                const dayContainer = createDayContainer(eventsData, day);
                multiSelectContainers.appendChild(dayContainer);
            }
        }

        // Función para crear un contenedor de día con sus selectores
        function createDayContainer(eventsData, dayNumber) {
            const dayContainer = document.createElement('div');
            dayContainer.className = 'day-container';

            const morningContainer = createMultiSelectBlock(eventsData, `Actividad mañana día ${dayNumber}`, `day${dayNumber}_morning`);
            dayContainer.appendChild(morningContainer);

            const afternoonContainer = createMultiSelectBlock(eventsData, `Actividad tarde día ${dayNumber}`, `day${dayNumber}_afternoon`);
            dayContainer.appendChild(afternoonContainer);

            return dayContainer;
        }

        // Función para crear un bloque de selectores múltiples
        function createMultiSelectBlock(eventsData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            eventsData.forEach(event => {
                const option = document.createElement('option');
                option.value = event.id;
                option.textContent = event.name;

                option.setAttribute('data-site-id', event.site_id);

                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });



            const selectedSiteId = document.querySelector('#sites_itinerary').value; 
            setTimeout(() => {
                const availableOptions__ = document.querySelectorAll('.available-options option'); 

                availableOptions__.forEach(option => {
                    const siteId = option.getAttribute('data-site-id');
                    //console.log(siteId+'>>'+selectedSiteId);
                    if (siteId === selectedSiteId) {
                        option.style.display = '';  
                    } else {
                        option.style.display = 'none';  
                    }
                });
            }, 500);

            return blockContainer;
        }

        // Función para mover opciones seleccionadas entre selectores
        function moveSelectedOptions(sourceSelect, destinationSelect) {
            const optionsToMove = Array.from(sourceSelect.selectedOptions);

            optionsToMove.forEach(option => {
                destinationSelect.appendChild(option);
            });

            markAllSelectedOptions();
        }

        // Función para marcar todas las opciones como seleccionadas
        function markAllSelectedOptions() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.endsWith('_selected[]')) {
                    const options = select.querySelectorAll('option');
                    options.forEach(option => {
                        option.selected = true;
                    });
                }
            });

            // Actualizar selecciones guardadas
            saveCurrentSelections();
        }

        // Función para guardar las selecciones actuales
        function saveCurrentSelections() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.includes('_selected[]')) {
                    selectionsBackup[select.name] = Array.from(select.selectedOptions).map(option => option.value);
                }
            });
        }

        // Función para cargar las opciones seleccionadas desde el JSON
        function loadSelectedOptions() {
            eventsSelected.forEach(event => {
                const selectName = `day${event.day}_${event.day_period}_selected[]`;
                const selectElement = document.querySelector(`select[name="${selectName}"]`);
                const availableOptions = document.querySelector(`select[name="day${event.day}_${event.day_period}_available[]"]`);
                
                if (selectElement && availableOptions) {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == event.place_id);
                    if (optionToMove) {
                        selectElement.appendChild(optionToMove);
                    }
                }
            });
            markAllSelectedOptions();
        }

    }

    const jsupdselectPlaces = document.querySelector('.js-upd-selectPlaces');
    
    if (jsupdselectPlaces) { 
        
        
        document.getElementById('btcreatePlace').addEventListener('click', function(event) {
            event.preventDefault();
            
            // Actualizar índices de imágenes y asegurar datos correctos antes de enviar
            if (typeof updateImageIndexes === 'function') {
                console.log('Updating image indexes before form submission');
                updateImageIndexes();
            }
            
            const form = document.getElementById('fCreatePlace');
            const formData = new FormData(form);

            document.querySelectorAll('.description').forEach(element => {
                const editorInstance = element.editorInstance;
                if (editorInstance) {
                    const editorData = editorInstance.getData();

                    /*const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = `${element.getAttribute('name')}_content`;
                    hiddenField.value = editorData;
                    
                    document.querySelector('#fCreatePlace').appendChild(hiddenField);*/

                    formData.append(`${element.getAttribute('name')}_content`, editorData);

                }
            });
            
            
        
            fetch(form.action, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('input[name="_token"]').value
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
        
                if (data.success) {
                    const placeSelect = window.parent.document.getElementById('place_id');
                    const siteSelect = window.parent.document.getElementById('site_id');
        
                    if (placeSelect) {
                        placeSelect.innerHTML = '';
                        const defaultOption = window.parent.document.createElement('option');
                        defaultOption.value = '';
                        defaultOption.textContent = 'No asociado';
                        placeSelect.appendChild(defaultOption);
        
                        // Agregar nuevas opciones de places
                        data.places.forEach(place => {
                            const option = window.parent.document.createElement('option');
                            option.value = place.id;
                            option.textContent = place.name;
                            option.setAttribute('place', place.site_id); 
                            placeSelect.appendChild(option);
                        });
        
                        // Seleccionar automáticamente el último lugar añadido
                        placeSelect.value = data.created_place_id;
        
                        // Deshabilitar siteSelect si placeSelect tiene seleccionado un lugar diferente a '0'
                        if (data.site_id !== '0') {
                            siteSelect.selectedIndex = Array.from(siteSelect.options).findIndex(option => option.value === data.site_id);
                            siteSelect.classList.add('select-disabled');
                        }
        
                        // Cerrar el modal después de actualizar el selector
                        const btCloseSitio = window.parent.document.getElementById('btCloseSitio');
                        btCloseSitio.click();
                    } else {
                        console.error('Elemento place_id no encontrado en la ventana principal');
                    }
        
                } else {
                    
                    alert('Hubo un error al enviar el formulario: ' + data.message);
                }
            })
            .catch(error => {
                //console.error('Error en la solicitud:', error); // Depuración: Ver errores de red u otros errores
                alert('Hubo un error al enviar el formulario');
            });
        });
        
        
    }


    const jsplans = document.querySelector('.js-plans');
    if (jsplans){
        const numberDaysInput = document.getElementById('number_days');
        const multiSelectContainers = document.getElementById('multiSelectContainers');
        const eventsData = JSON.parse(document.getElementById('eventsData').value);
        const eventsSelected = JSON.parse(document.getElementById('eventsSelected').value);

        // Objeto para almacenar las selecciones de cada selector
        let selectionsBackup = {};
        
        // Inicialización al cargar la página
        initialize();

        // Función para inicializar el número de días y los selectores
        function initialize() {
            const numberDays = parseInt(numberDaysInput.value);
            createMultiSelectContainers(numberDays);
            loadSelectedOptions();
        }

        // Escuchar cambios en el input number_days
        numberDaysInput.addEventListener('change', function() {
            const numberDays = parseInt(this.value);
            updateMultiSelectContainers(numberDays);
        });

        // Función para actualizar los selectores
        function updateMultiSelectContainers(numberDays) {
            const currentNumberDays = multiSelectContainers.children.length;

            if (numberDays > currentNumberDays) {
                // Agregar selectores adicionales si se necesita
                for (let day = currentNumberDays + 1; day <= numberDays; day++) {
                    const dayContainer = createDayContainer(eventsData, day);
                    multiSelectContainers.appendChild(dayContainer);
                }
            } else if (numberDays < currentNumberDays) {
                // Eliminar el último selector si se necesita
                while (multiSelectContainers.children.length > numberDays) {
                    multiSelectContainers.removeChild(multiSelectContainers.lastChild);
                }
            }
            loadSelectedOptions();
        }

        // Función para crear todos los selectores iniciales
        function createMultiSelectContainers(numberDays) {
            for (let day = 1; day <= numberDays; day++) {
                const dayContainer = createDayContainer(eventsData, day);
                multiSelectContainers.appendChild(dayContainer);
            }
        }

        // Función para crear un contenedor de día con sus selectores
        function createDayContainer(eventsData, dayNumber) {
            const dayContainer = document.createElement('div');
            dayContainer.className = 'day-container';

            const morningContainer = createMultiSelectBlock(eventsData, `Actividad mañana día ${dayNumber}`, `day${dayNumber}_morning`);
            dayContainer.appendChild(morningContainer);

            const afternoonContainer = createMultiSelectBlock(eventsData, `Actividad tarde día ${dayNumber}`, `day${dayNumber}_afternoon`);
            dayContainer.appendChild(afternoonContainer);

            return dayContainer;
        }

        // Función para crear un bloque de selectores múltiples
        function createMultiSelectBlock(eventsData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            eventsData.forEach(event => {
                const option = document.createElement('option');
                option.value = event.id;
                option.textContent = event.name;
                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });

            return blockContainer;
        }

        // Función para mover opciones seleccionadas entre selectores
        function moveSelectedOptions(sourceSelect, destinationSelect) {
            const optionsToMove = Array.from(sourceSelect.selectedOptions);

            optionsToMove.forEach(option => {
                destinationSelect.appendChild(option);
            });

            markAllSelectedOptions();
        }

        // Función para marcar todas las opciones como seleccionadas
        function markAllSelectedOptions() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.endsWith('_selected[]')) {
                    const options = select.querySelectorAll('option');
                    options.forEach(option => {
                        option.selected = true;
                    });
                }
            });

            // Actualizar selecciones guardadas
            saveCurrentSelections();
        }

        // Función para guardar las selecciones actuales
        function saveCurrentSelections() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.includes('_selected[]')) {
                    selectionsBackup[select.name] = Array.from(select.selectedOptions).map(option => option.value);
                }
            });
        }

        // Función para cargar las opciones seleccionadas desde el JSON
        function loadSelectedOptions() {
            eventsSelected.forEach(event => {
                const selectName = `day${event.day}_${event.day_period}_selected[]`;
                const selectElement = document.querySelector(`select[name="${selectName}"]`);
                const availableOptions = document.querySelector(`select[name="day${event.day}_${event.day_period}_available[]"]`);
                
                if (selectElement && availableOptions) {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == event.event_id);
                    if (optionToMove) {
                        selectElement.appendChild(optionToMove);
                    }
                }
            });
            markAllSelectedOptions();
        }

    }

    

    const jspages = document.querySelector('.js-pages');
    if (jspages){
        /*
        document.querySelectorAll('.description').forEach(element => {
            const initialValue = element.getAttribute('data-content') || '';

            ClassicEditor
                .create(element, {
                    plugins: [Essentials, Bold, Italic, Font, Paragraph, Heading, List, Image, ImageUpload],
                    toolbar: {
                        items: [
                            'undo', 'redo', '|', 'heading', '|',
                            'bold', 'italic', '|',
                            'numberedList', 'bulletedList', '|',
                            'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor',
                            'imageUpload',  
                        ]
                    },
                    image: {
                        toolbar: [
                            'imageTextAlternative',  // Agregar el campo de texto alternativo para imágenes
                            'imageStyle:full',  // Opciones adicionales de estilo de imagen si es necesario
                            'imageStyle:alignLeft',
                            'imageStyle:alignRight'
                        ],
                        styles: [
                            'full',
                            'alignLeft',
                            'alignRight'
                        ]
                    },
                    upload: {
                        uploadUrl: '/upload-image'
                    },
                    data: {
                        allowAttributes: true,
                        allowTags: true,
                    },
                    autoGrowMinHeight: 500, // Mantener la altura mínima en 500px
                    autoGrow: {
                        minHeight: 500
                    }
                })
                .then(editor => {
                    element.editorInstance = editor;
                })
                .catch(error => {
                    console.error('Error creating editor:', error);
                });
        });
        */
        const typeSelect = document.querySelector('#type');

        typeSelect.addEventListener('change', function(event) {
            event.preventDefault(); 
            const selectedType = this.value;

            const types = ['pagina', 'multimedia', 'documentpdf', 'pueblos'];
            

            types.forEach(function(type) {
                const elements = document.querySelectorAll('.l' + type);
                elements.forEach(function(el) {
                    if (type === selectedType) {
                        el.classList.remove('d-none');
                    } else {
                        el.classList.add('d-none');
                    }
                });
            });
            const lambos = document.querySelectorAll('.lambos');
            if (typeSelect.value == 'pagina' || typeSelect.value == 'pueblos' || typeSelect.value == 'multimedia') {
                lambos.forEach(function(el) {
                    el.classList.remove('d-none');
                }); 
            }else{
                lambos.forEach(function(el) {
                    el.classList.add('d-none');
                });
            }

            const lpaginaMultimedia = document.querySelectorAll('.lpagina-multimedia');
            if (typeSelect.value == 'pagina' || typeSelect.value == 'multimedia') {
                lpaginaMultimedia.forEach(function(el) {
                    el.classList.remove('d-none');
                });
            } else {
                lpaginaMultimedia.forEach(function(el) {
                    el.classList.add('d-none');
                });
            }
            
        });
        
        typeSelect.dispatchEvent(new Event('change'));


        document.querySelector('#btcreatePage').addEventListener('click', function(event) {
            event.preventDefault(); 

            document.querySelectorAll('.description').forEach(element => {
                const editorInstance = element.editorInstance;
                if (editorInstance) {
                    const editorData = editorInstance.getData();

                    const hiddenField = document.createElement('input');
                    hiddenField.type = 'hidden';
                    hiddenField.name = `${element.getAttribute('name')}_content`;
                    hiddenField.value = editorData;
                    document.querySelector('#fCreatePage').appendChild(hiddenField);
                }
            });

            // Actualizar los campos hidden para multimedia, documentos PDF y documentlists antes de enviar
            updateHiddenInput();
            updateHiddenInput2();
            updateHiddenInput3();

            document.querySelector('#fCreatePage').submit();
        });

        //multiselectores
        const multiSelectContainers = document.getElementById("multiSelectContainers");
        const documentlistsData = JSON.parse(document.getElementById("documentlistsData").value);
        const documentlistsSelected = JSON.parse(document.getElementById("documentlistsSelected").value);

        const multiSelectContainers2 = document.getElementById('multiSelectContainers2');
        const multimediasData = JSON.parse(document.getElementById('multimediasData').value);
        const multimediasSelected = JSON.parse(document.getElementById('multimediasSelected').value);

        const multiSelectContainers3 = document.getElementById('multiSelectContainers3');
        const documentpdfsData = JSON.parse(document.getElementById('documentpdfsData').value);
        const documentpdfsSelected = JSON.parse(document.getElementById('documentpdfsSelected').value);


        function createMultiSelector() {
            const container = document.createElement("div");
            container.className = "row multi-select-container";

            // Crear la columna de documentos disponibles y el selector de seleccionados
            const availableColumn = createAvailableColumn(documentlistsData);
            const selectedSelect = createSelect([], "selected-options", "documentlists_selected[]");

            container.appendChild(availableColumn);
            container.appendChild(createColumn("Grupo documentos seleccionados", selectedSelect));

            multiSelectContainers.appendChild(container);

            // Cargar las opciones seleccionadas previamente
            loadSelectedOptions(availableColumn.querySelector("select"), selectedSelect);

            // Añadir eventos de click para mover las opciones
            addMoveEvents(availableColumn.querySelector("select"), selectedSelect);
            addMoveEvents(selectedSelect, availableColumn.querySelector("select"));


            //contenido multimedia
            const container2 = document.createElement("div");
            container2.className = "row multi-select-container";

            const availableColumn2 = createAvailableColumn2(multimediasData);
            const selectedSelect2 = createSelect([], "selected-options", "multimedias_selected[]");

            container2.appendChild(availableColumn2);
            container2.appendChild(createColumn("Multimedia seleccionados", selectedSelect2));

            multiSelectContainers2.appendChild(container2);

            // Cargar las opciones seleccionadas previamente
            loadSelectedOptions2(availableColumn2.querySelector("select"), selectedSelect2);

            // Añadir eventos de click para mover las opciones
            addMoveEvents(availableColumn2.querySelector("select"), selectedSelect2);
            addMoveEvents(selectedSelect2, availableColumn2.querySelector("select"));

            //contenido documentos pdf
            const container3 = document.createElement("div");
            container3.className = "row multi-select-container";

            const availableColumn3 = createAvailableColumn3(documentpdfsData);
            const selectedSelect3 = createSelect([], "selected-options", "documentpdfs_selected[]");

            container3.appendChild(availableColumn3);
            container3.appendChild(createColumn("Documentos PDF seleccionados", selectedSelect3));

            multiSelectContainers3.appendChild(container3);

            // Cargar las opciones seleccionadas previamente
            loadSelectedOptions3(availableColumn3.querySelector("select"), selectedSelect3);

            // Añadir eventos de click para mover las opciones
            addMoveEvents(availableColumn3.querySelector("select"), selectedSelect3);
            addMoveEvents(selectedSelect3, availableColumn3.querySelector("select"));



            updateHiddenInput();
            updateHiddenInput2();
            updateHiddenInput3();
            
        }

        function createAvailableColumn(documentlistsData) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = "Grupo documentos disponibles";
            column.appendChild(label);

            const searchInput = document.createElement("input");
            searchInput.type = "text";
            searchInput.className = "form-control mb-2";
            searchInput.placeholder = "Buscar...";
            column.appendChild(searchInput);

            const availableSelect = createSelect(documentlistsData, "available-options", "documentlists_available[]");
            column.appendChild(availableSelect);

            searchInput.addEventListener("input", function () {
                filterOptions(availableSelect, searchInput.value);
            });

            return column;
        }
        function createAvailableColumn2(multimediasData) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = "Multimedia";
            column.appendChild(label);

            const searchInput = document.createElement("input");
            searchInput.type = "text";
            searchInput.className = "form-control mb-2";
            searchInput.placeholder = "Buscar...";
            column.appendChild(searchInput);

            const availableSelect = createSelect(multimediasData, "available-options", "multimedias_available[]");
            column.appendChild(availableSelect);

            searchInput.addEventListener("input", function () {
                filterOptions(availableSelect, searchInput.value);
            });

            return column;
        }

        function createAvailableColumn3(documentpdfsData) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = "Documentos PDF";
            column.appendChild(label);

            const searchInput = document.createElement("input");
            searchInput.type = "text";
            searchInput.className = "form-control mb-2";
            searchInput.placeholder = "Buscar...";
            column.appendChild(searchInput);

            const availableSelect = createSelect(documentpdfsData, "available-options", "documentpdfs_available[]");
            column.appendChild(availableSelect);

            searchInput.addEventListener("input", function () {
                filterOptions(availableSelect, searchInput.value);
            });

            return column;
        }


        function createSelect(options, className, name) {
            const select = document.createElement("select");
            select.className = `form-control ${className}`;
            select.setAttribute("multiple", true);
            select.setAttribute("size", 8);
            select.setAttribute("name", name);

            options.forEach(doc => {
                const option = document.createElement("option");
                option.value = doc.id;
                option.textContent = doc.name;
                select.appendChild(option);
            });

            return select;
        }

        function createColumn(labelText, selectElement) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = labelText;
            column.appendChild(label);
            column.appendChild(selectElement);

            return column;
        }

        function addMoveEvents(sourceSelect, destinationSelect) {
            sourceSelect.addEventListener("click", function () {
                
                Array.from(sourceSelect.selectedOptions).forEach(option => {
                    destinationSelect.appendChild(option);
                });
                updateHiddenInput();
                updateHiddenInput2();
                updateHiddenInput3();
            });
        }

        function updateHiddenInput() {
            // Verificamos que exista el elemento documentlistsHidden
            const documentlistsHidden = document.getElementById("documentlistsHidden");
            if (!documentlistsHidden) {
                console.error("Elemento documentlistsHidden no encontrado");
                return; // Si no existe, salimos de la función
            }
        
            // Obtenemos todas las opciones del select de documentlists seleccionada
            const selectedSelect = document.querySelector('select[name="documentlists_selected[]"]');
            if (!selectedSelect) {
                documentlistsHidden.value = "[]";
                return;
            }

            const selectedOptions = selectedSelect.querySelectorAll('option');
            if (selectedOptions.length === 0) {
                documentlistsHidden.value = "[]"; // Ponemos un array vacío si no hay opciones seleccionadas
                return;
            }
        
            // Extraemos los valores de todas las opciones
            const selectedIds = Array.from(selectedOptions).map(option => option.value);
        
            // Actualizamos el campo hidden con los valores seleccionados
            documentlistsHidden.value = JSON.stringify(selectedIds);
        }

        function updateHiddenInput2() {
            // Verificamos que exista el elemento multimediasHidden
            const multimediasHidden = document.getElementById("multimediasHidden");
            if (!multimediasHidden) {
                console.error("Elemento multimediasHidden no encontrado");
                return; // Si no existe, salimos de la función
            }
        
            // Obtenemos todas las opciones del select de multimedia seleccionada
            const selectedSelect = document.querySelector('select[name="multimedias_selected[]"]');
            if (!selectedSelect) {
                multimediasHidden.value = "[]";
                return;
            }

            const selectedOptions = selectedSelect.querySelectorAll('option');
            if (selectedOptions.length === 0) {
                multimediasHidden.value = "[]"; // Ponemos un array vacío si no hay opciones seleccionadas
                return;
            }
        
            // Extraemos los valores de todas las opciones
            const selectedIds = Array.from(selectedOptions).map(option => option.value);
        
            // Actualizamos el campo hidden con los valores seleccionados
            multimediasHidden.value = JSON.stringify(selectedIds);
        }

        function updateHiddenInput3() {
            // Verificamos que exista el elemento documentpdfsHidden
            const documentpdfsHidden = document.getElementById("documentpdfsHidden");
            if (!documentpdfsHidden) {
                console.error("Elemento documentpdfsHidden no encontrado");
                return; // Si no existe, salimos de la función
            }
        
            // Obtenemos todas las opciones del select de documentpdf seleccionada
            const selectedSelect = document.querySelector('select[name="documentpdfs_selected[]"]');
            if (!selectedSelect) {
                documentpdfsHidden.value = "[]";
                return;
            }

            const selectedOptions = selectedSelect.querySelectorAll('option');
            if (selectedOptions.length === 0) {
                documentpdfsHidden.value = "[]"; // Ponemos un array vacío si no hay opciones seleccionadas
                return;
            }
        
            // Extraemos los valores de todas las opciones
            const selectedIds = Array.from(selectedOptions).map(option => option.value);
        
            // Actualizamos el campo hidden con los valores seleccionados
            documentpdfsHidden.value = JSON.stringify(selectedIds);
        }
        
        

        function loadSelectedOptions(availableSelect, selectedSelect) {
            // Asegurarnos de que las opciones seleccionadas son las correctas
            documentlistsSelected.forEach(selectedDoc => {
                // Encontramos el grupo documentos correspondiente en el array de datos
                const optionToMove = Array.from(availableSelect.options).find(opt => opt.value == selectedDoc.documentlist_id);
                if (optionToMove) {
                    selectedSelect.appendChild(optionToMove); // Mover la opción seleccionada
                }
            });

            
            updateHiddenInput();
            //updateHiddenInput2();
            //updateHiddenInput3();
        }

        function loadSelectedOptions2(availableSelect2, selectedSelect2) {
            // Asegurarnos de que las opciones seleccionadas son las correctas
            multimediasSelected.forEach(selectedDoc => {
                // Encontramos el grupo documentos correspondiente en el array de datos
                const optionToMove = Array.from(availableSelect2.options).find(opt => opt.value == selectedDoc.multimedia_id);
                if (optionToMove) {
                    selectedSelect2.appendChild(optionToMove); // Mover la opción seleccionada
                }
            });

            
            //updateHiddenInput();
            updateHiddenInput2();
            //updateHiddenInput3();
        }

        function loadSelectedOptions3(availableSelect3, selectedSelect3) {
            // Asegurarnos de que las opciones seleccionadas son las correctas
            documentpdfsSelected.forEach(selectedDoc => {
                // Encontramos el grupo documentos correspondiente en el array de datos
                const optionToMove = Array.from(availableSelect3.options).find(opt => opt.value == selectedDoc.documentpdf_id);
                if (optionToMove) {
                    selectedSelect3.appendChild(optionToMove); // Mover la opción seleccionada
                }
            });

            
            //updateHiddenInput();
            //updateHiddenInput2();
            updateHiddenInput3();
        }

        function filterOptions(select, searchTerm) {
            Array.from(select.options).forEach(option => {
                const text = option.textContent.toLowerCase();
                option.style.display = text.includes(searchTerm.toLowerCase()) ? "" : "none";
            });
        }

        // Inicializar la creación del selector
        createMultiSelector();



        //fin multiselectores
                

    }
    

    
    

    const jsdistributor = document.querySelector('.js-distributor');
    if (jsdistributor) {
        const multiSelectContainers = document.getElementById('multiSelectContainers');
        const pagesData = JSON.parse(document.getElementById('pagesData').value);
        const pagesSelected = JSON.parse(document.getElementById('pagesSelected').value);

        const multiSelectContainers2 = document.getElementById('multiSelectContainers2');
        //const multimediasData = JSON.parse(document.getElementById('multimediasData').value);
        //const multimediasSelected = JSON.parse(document.getElementById('multimediasSelected').value);

        const multiSelectContainers3 = document.getElementById('multiSelectContainers3');
        const tarjetasData = JSON.parse(document.getElementById('tarjetasData').value);
        const tarjetasSelected = JSON.parse(document.getElementById('tarjetasSelected').value);

        const multiSelectContainers4 = document.getElementById('multiSelectContainers4');
        const filterplacesData = JSON.parse(document.getElementById('filterplacesData').value);
        const filterplacesSelected = JSON.parse(document.getElementById('filterplacesSelected').value);

        const activitiesData = (() => {
            const el = document.getElementById('activitiesData');
            return el ? JSON.parse(el.value) : [];
        })();
        const featuredSelect = document.getElementById('featured_activity');
        const featuredSelectedInput = document.getElementById('featuredActivitySelected');

        const typeSelect = document.getElementById('type');
        const lactividadElements = document.querySelectorAll('.lactividad');
        const lpagesElements = document.querySelectorAll('.lpages');
        const lplacesElements = document.querySelectorAll('.lplaces');
        const lfilterplaceElements = document.querySelectorAll('.lfilterplaces');
        //const lmultimediaElements = document.querySelectorAll('.lmultimedias');
        const ltarjetaElements = document.querySelectorAll('.ltarjetas');
        //const lnumeroElements = document.querySelectorAll('.lnumero');//ls:: lo comento porque la programación no lo tiene en cuenta

        typeSelect.addEventListener('change', () => {
            const selectedValue = typeSelect.value;
            
            if (selectedValue === 'actividades') {
                lactividadElements.forEach(el => el.classList.remove('d-none'));
                lpagesElements.forEach(el => el.classList.add('d-none'));
                lplacesElements.forEach(el => el.classList.add('d-none'));
                lfilterplaceElements.forEach(el => el.classList.add('d-none'));
                //lmultimediaElements.forEach(el => el.classList.add('d-none'));
                ltarjetaElements.forEach(el => el.classList.add('d-none'));
                //lnumeroElements.forEach(el => el.classList.remove('d-none'));//ls:: lo comento porque la programación no lo tiene en cuenta
            } else if (selectedValue === 'paginacorporativa') {
                lactividadElements.forEach(el => el.classList.add('d-none'));
                lpagesElements.forEach(el => el.classList.remove('d-none'));
                lplacesElements.forEach(el => el.classList.add('d-none'));
                lfilterplaceElements.forEach(el => el.classList.add('d-none'));
                ltarjetaElements.forEach(el => el.classList.add('d-none'));
                //lmultimediaElements.forEach(el => el.classList.add('d-none'));
                //lnumeroElements.forEach(el => el.classList.add('d-none'));//ls:: lo comento porque la programación no lo tiene en cuenta
            }else if (selectedValue == 'places'){
                lactividadElements.forEach(el => el.classList.add('d-none'));
                lpagesElements.forEach(el => el.classList.add('d-none'));
                lplacesElements.forEach(el => el.classList.remove('d-none'));
                lfilterplaceElements.forEach(el => el.classList.remove('d-none'));
                ltarjetaElements.forEach(el => el.classList.add('d-none'));
                //lmultimediaElements.forEach(el => el.classList.add('d-none'));
                //lnumeroElements.forEach(el => el.classList.remove('d-none'));//ls:: lo comento porque la programación no lo tiene en cuenta
            }else if (selectedValue == 'multimedia') {
                lactividadElements.forEach(el => el.classList.add('d-none'));
                lpagesElements.forEach(el => el.classList.add('d-none'));
                lplacesElements.forEach(el => el.classList.add('d-none'));
                lfilterplaceElements.forEach(el => el.classList.add('d-none'));
                ltarjetaElements.forEach(el => el.classList.add('d-none'));
                //lmultimediaElements.forEach(el => el.classList.remove('d-none'));
            }else{
                lactividadElements.forEach(el => el.classList.add('d-none'));
                lpagesElements.forEach(el => el.classList.add('d-none'));
                lplacesElements.forEach(el => el.classList.add('d-none'));
                lfilterplaceElements.forEach(el => el.classList.add('d-none'));
                //lmultimediaElements.forEach(el => el.classList.add('d-none'));
                ltarjetaElements.forEach(el => el.classList.remove('d-none'));
            }
        });

        // Trigger the change event to set the initial state
        typeSelect.dispatchEvent(new Event('change'));

        // Populate featured activity select based on filters
        function populateFeaturedSelect() {
            if (!featuredSelect) return;
            // remove existing options except the first placeholder
            const placeholder = featuredSelect.querySelector('option[value=""]');
            featuredSelect.innerHTML = '';
            if (placeholder) featuredSelect.appendChild(placeholder);

            const interestId = document.getElementById('interest_id') ? document.getElementById('interest_id').value : '';
            const filtereventId = document.getElementById('filterevent_id') ? document.getElementById('filterevent_id').value : '';

            const filtered = activitiesData.filter(a => {
                if (interestId && interestId !== '') {
                    if (!a.interest_ids || a.interest_ids.length === 0) return false;
                    if (!a.interest_ids.includes(parseInt(interestId))) return false;
                }
                if (filtereventId && filtereventId !== '') {
                    if (!a.filterevent_ids || a.filterevent_ids.length === 0) return false;
                    if (!a.filterevent_ids.includes(parseInt(filtereventId))) return false;
                }
                return true;
            });

            // If we're editing and there is a previously selected featured activity,
            // ensure it's present in the options even if it doesn't match current filters.
            if (featuredSelectedInput && featuredSelectedInput.value) {
                const selectedId = parseInt(featuredSelectedInput.value);
                const alreadyIncluded = filtered.some(x => parseInt(x.id) === selectedId);
                if (!alreadyIncluded) {
                    const exist = activitiesData.find(x => parseInt(x.id) === selectedId);
                    if (exist) filtered.unshift(exist); // add at top
                }
            }

            filtered.forEach(item => {
                const opt = document.createElement('option');
                opt.value = item.id;
                opt.textContent = item.name;
                featuredSelect.appendChild(opt);
            });

            // Set previously selected value if any
            if (featuredSelectedInput && featuredSelectedInput.value) {
                featuredSelect.value = featuredSelectedInput.value;
            }
        }

        // Listen to changes in interest and filterevent to repopulate
        const interestEl = document.getElementById('interest_id');
        const filtereventEl = document.getElementById('filterevent_id');
        if (interestEl) interestEl.addEventListener('change', populateFeaturedSelect);
        if (filtereventEl) filtereventEl.addEventListener('change', populateFeaturedSelect);

        // Initial population
        populateFeaturedSelect();



        // Objeto para almacenar las selecciones de cada selector
        let selectionsBackup = {};

        // Inicialización al cargar la página
        initialize();

        // Inicializa la interfaz de usuario
        function initialize() {
            createPageContainer();
            //createMultimediaContainer();
            createTarjetaContainer();
            createFilterplaceContainer();
            loadSelectedOptions();
            //loadSelectedMultimediaOptions();
            loadSelectedTarjetaOptions();
            loadSelectedFilterplaceOptions();
        }

        // Función para crear el contenedor de selección
        function createPageContainer() {
            const container = document.createElement('div');
            container.className = 'page-container';
            const selectBlock = createSelectBlock(pagesData, 'Páginas corporativas', 'paginas_corporativas');
            container.appendChild(selectBlock);
            multiSelectContainers.appendChild(container);
            
        }
        /*
        function createMultimediaContainer() {
            const container = document.createElement('div');
            container.className = 'multimedia-container';
            const selectBlock = createSelectBlock2(multimediasData, 'Multimedia', 'multimedias');
            container.appendChild(selectBlock);
            multiSelectContainers2.appendChild(container);
            
        }

        // Crea un bloque de selectores múltiples
        function createSelectBlock2(multimediasData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            multimediasData.forEach(multimedia => {
                const option = document.createElement('option');
                option.value = multimedia.id;
                option.textContent = multimedia.name;
                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });
            return blockContainer;
        }
    */
        function createTarjetaContainer() {
            const container = document.createElement('div');
            container.className = 'tarjeta-container';
            const selectBlock = createSelectBlock3(tarjetasData, 'Tarjetas', 'tarjetas');
            container.appendChild(selectBlock);
            multiSelectContainers3.appendChild(container);
            
        }

        function createFilterplaceContainer() {
            const container = document.createElement('div');
            container.className = 'filterplace-container';
            const selectBlock = createSelectBlock4(filterplacesData, 'Filtros que se mostrarán en el listado', 'filterplaces');
            container.appendChild(selectBlock);
            multiSelectContainers4.appendChild(container);
            
        }

        // Crea un bloque de selectores múltiples
        function createSelectBlock3(tarjetasData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            tarjetasData.forEach(tarjeta => {
                const option = document.createElement('option');
                option.value = tarjeta.id;
                option.textContent = tarjeta.name;
                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });
            return blockContainer;
        }

        function createSelectBlock(pagesData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            pagesData.forEach(page => {
                const option = document.createElement('option');
                option.value = page.id;
                option.textContent = page.name;
                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });

            return blockContainer;
        }

        // Crea un bloque de selectores múltiples para filterplaces
        function createSelectBlock4(filterplacesData, labelText, namePrefix) {
            const blockContainer = document.createElement('div');
            blockContainer.className = 'row multi-select-container my-2';

            const label = document.createElement('label');
            label.className = 'col-12';
            label.textContent = labelText;
            blockContainer.appendChild(label);

            const selectColumn = document.createElement('div');
            selectColumn.className = 'col-6';

            const availableOptions = document.createElement('select');
            availableOptions.setAttribute('multiple', true);
            availableOptions.setAttribute('size', 5);
            availableOptions.classList.add('available-options', 'fixed-size-select', 'form-control');
            availableOptions.setAttribute('name', `${namePrefix}_available[]`);

            filterplacesData.forEach(filterplace => {
                const option = document.createElement('option');
                option.value = filterplace.id;
                option.textContent = filterplace.name;
                availableOptions.appendChild(option);
            });

            selectColumn.appendChild(availableOptions);
            blockContainer.appendChild(selectColumn);

            const selectedOptionsContainer = document.createElement('div');
            selectedOptionsContainer.className = 'col-6';

            const selectedOptions = document.createElement('select');
            selectedOptions.setAttribute('multiple', true);
            selectedOptions.setAttribute('size', 5);
            selectedOptions.classList.add('selected-options', 'fixed-size-select', 'form-control');
            selectedOptions.setAttribute('name', `${namePrefix}_selected[]`);

            selectedOptionsContainer.appendChild(selectedOptions);
            blockContainer.appendChild(selectedOptionsContainer);

            availableOptions.addEventListener('change', function() {
                moveSelectedOptions(this, selectedOptions);
            });

            selectedOptions.addEventListener('change', function() {
                moveSelectedOptions(this, availableOptions);
            });

            return blockContainer;
        }

        // Mueve las opciones seleccionadas entre los selectores
        function moveSelectedOptions(sourceSelect, destinationSelect) {
            const optionsToMove = Array.from(sourceSelect.selectedOptions);
            optionsToMove.forEach(option => {
                destinationSelect.appendChild(option);
            });
            markAllSelectedOptions();
        }

        // Marca todas las opciones seleccionadas
        function markAllSelectedOptions() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.endsWith('_selected[]')) {
                    const options = select.querySelectorAll('option');
                    options.forEach(option => {
                        option.selected = true;
                    });
                }
            });
            saveCurrentSelections();
        }

        // Guarda las selecciones actuales
        function saveCurrentSelections() {
            const selects = document.querySelectorAll('select');
            selects.forEach(select => {
                if (select.name && select.name.includes('_selected[]')) {
                    selectionsBackup[select.name] = Array.from(select.selectedOptions).map(option => option.value);
                }
            });
        }

        // Carga las opciones seleccionadas desde el JSON
        function loadSelectedOptions() {
            const selectedOptions = document.querySelector('select[name$="paginas_corporativas_selected[]"]');
            const availableOptions = document.querySelector('select[name$="paginas_corporativas_available[]"]');

            if (selectedOptions && availableOptions) {
                pagesSelected.forEach(page => {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == page.page_id);
                    if (optionToMove) {
                        selectedOptions.appendChild(optionToMove);
                    }
                });
                markAllSelectedOptions();
            }
        }

        /*function loadSelectedMultimediaOptions(){
            const selectedOptions = document.querySelector('select[name$="multimedias_selected[]"]');
            const availableOptions = document.querySelector('select[name$="multimedias_available[]"]');

            if (selectedOptions && availableOptions) {
                
                multimediasSelected.forEach(multimedia => {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == multimedia.multimedia_id);
                    if (optionToMove) {
                        selectedOptions.appendChild(optionToMove);
                    }
                });
                markAllSelectedOptions();
            }
        }*/
        function loadSelectedTarjetaOptions(){
            const selectedOptions = document.querySelector('select[name$="tarjetas_selected[]"]');
            const availableOptions = document.querySelector('select[name$="tarjetas_available[]"]');

            if (selectedOptions && availableOptions) {
                
                tarjetasSelected.forEach(tarjeta => {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == tarjeta.infocard_id);
                    if (optionToMove) {
                        selectedOptions.appendChild(optionToMove);
                    }
                });
                markAllSelectedOptions();
            }
        }

        function loadSelectedFilterplaceOptions(){
            const selectedOptions = document.querySelector('select[name$="filterplaces_selected[]"]');
            const availableOptions = document.querySelector('select[name$="filterplaces_available[]"]');

            if (selectedOptions && availableOptions) {
                
                filterplacesSelected.forEach(filterplace => {
                    const optionToMove = Array.from(availableOptions.options).find(option => option.value == filterplace.filterplace_id);
                    if (optionToMove) {
                        selectedOptions.appendChild(optionToMove);
                    }
                });
                markAllSelectedOptions();
            }
        }
        
    }
    
    const jsdocumentlist = document.querySelector('.js-documentlist');
    if (jsdocumentlist) {
        const multiSelectContainers = document.getElementById("multiSelectContainers");
        const documentsData = JSON.parse(document.getElementById("documentsData").value);
        const documentsSelected = JSON.parse(document.getElementById("documentsSelected").value);

        function createMultiSelector() {
            const container = document.createElement("div");
            container.className = "row multi-select-container";

            // Crear la columna de documentos disponibles y el selector de seleccionados
            const availableColumn = createAvailableColumn(documentsData);
            const selectedSelect = createSelect([], "selected-options", "documents_selected[]");

            container.appendChild(availableColumn);
            container.appendChild(createColumn("Documentos seleccionados", selectedSelect));

            multiSelectContainers.appendChild(container);

            // Cargar las opciones seleccionadas previamente
            loadSelectedOptions(availableColumn.querySelector("select"), selectedSelect);

            // Añadir eventos de click para mover las opciones
            addMoveEvents(availableColumn.querySelector("select"), selectedSelect);
            addMoveEvents(selectedSelect, availableColumn.querySelector("select"));

            updateHiddenInput();
        }

        function createAvailableColumn(documentsData) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = "Documentos disponibles";
            column.appendChild(label);

            const searchInput = document.createElement("input");
            searchInput.type = "text";
            searchInput.className = "form-control mb-2";
            searchInput.placeholder = "Buscar documento...";
            column.appendChild(searchInput);

            const availableSelect = createSelect(documentsData, "available-options", "documents_available[]");
            column.appendChild(availableSelect);

            searchInput.addEventListener("input", function () {
                filterOptions(availableSelect, searchInput.value);
            });

            return column;
        }

        function createSelect(options, className, name) {
            const select = document.createElement("select");
            select.className = `form-control ${className}`;
            select.setAttribute("multiple", true);
            select.setAttribute("size", 8);
            select.setAttribute("name", name);

            options.forEach(doc => {
                const option = document.createElement("option");
                option.value = doc.id;
                option.textContent = doc.name;
                select.appendChild(option);
            });

            return select;
        }

        function createColumn(labelText, selectElement) {
            const column = document.createElement("div");
            column.className = "col-5";

            const label = document.createElement("label");
            label.textContent = labelText;
            column.appendChild(label);
            column.appendChild(selectElement);

            return column;
        }

        function addMoveEvents(sourceSelect, destinationSelect) {
            sourceSelect.addEventListener("click", function () {
                
                Array.from(sourceSelect.selectedOptions).forEach(option => {
                    destinationSelect.appendChild(option);
                });
                updateHiddenInput();
            });
        }

        function updateHiddenInput() {
            // Verificamos que exista el elemento documentsHidden
            const documentsHidden = document.getElementById("documentsHidden");
            if (!documentsHidden) {
                console.error("Elemento documentsHidden no encontrado");
                return; // Si no existe, salimos de la función
            }

            // Verificamos que existan opciones seleccionadas
            const selectedOptions = document.querySelectorAll(".selected-options option");
            if (selectedOptions.length === 0) {
                documentsHidden.value = "[]"; // Ponemos un array vacío si no hay opciones seleccionadas
                return;
            }

            // Extraemos los valores de las opciones seleccionadas
            const selectedIds = Array.from(selectedOptions).map(option => option.value);

            // Actualizamos el campo hidden con los valores seleccionados
            documentsHidden.value = JSON.stringify(selectedIds);
        }
        
        

        function loadSelectedOptions(availableSelect, selectedSelect) {
            // Asegurarnos de que las opciones seleccionadas son las correctas
            documentsSelected.forEach(selectedDoc => {
                // Encontramos el documento correspondiente en el array de datos
                const optionToMove = Array.from(availableSelect.options).find(opt => opt.value == selectedDoc.document_id);
                if (optionToMove) {
                    selectedSelect.appendChild(optionToMove); // Mover la opción seleccionada
                }
            });

            updateHiddenInput();
        }

        function filterOptions(select, searchTerm) {
            Array.from(select.options).forEach(option => {
                const text = option.textContent.toLowerCase();
                option.style.display = text.includes(searchTerm.toLowerCase()) ? "" : "none";
            });
        }

        // Inicializar la creación del selector
        createMultiSelector();

    }

    // mostrar/ocultar campos del Camino de Santiago en  create y update
    const jsCamino = document.querySelector('.js-camino');
    if (jsCamino) {
        const caminoCheckbox = document.getElementById('is_camino_santiago');
        const caminoSections = document.querySelectorAll('.lcamino');

        // Función para mostrar/ocultar los divs del Camino de Santiago
        function toggleCaminoSections() {
            if (caminoCheckbox && caminoCheckbox.checked) {
                caminoSections.forEach(section => {
                    section.style.display = 'block';
                });
            } else {
                caminoSections.forEach(section => {
                    section.style.display = 'none';
                });
            }
        }

        // Inicializar para update)
        if (caminoCheckbox) {
            toggleCaminoSections();

            caminoCheckbox.addEventListener('change', function() {
                toggleCaminoSections();
            });
        }
    }

    
});


